(function () {
  'use strict';
  if (window.SBQ_CAPTURE) return;
  const ENDPOINT = 'https://app.songbond.com/api/shopify/lead';
  // Old partial_briefs acknowledgements do not acknowledge the lead door.
  const PREFIX = 'sbq_shopify_lead_v1:';
  const ATTRIBUTION_KEY = 'sbq_shopify_attribution_v1';
  const BRIEF_ID = /^[A-Za-z0-9_-]{8,64}$/;
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const ATTRIBUTION_FIELDS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid','ttclid'];
  const RETRY_DELAYS = [2000, 8000];
  const MAX_ATTEMPTS = RETRY_DELAYS.length + 1;
  const records = new Map();
  const listeners = new Set();
  const clone = value => JSON.parse(JSON.stringify(value));
  const text = value => typeof value === 'string' ? value : '';
  const signatureOf = payload => JSON.stringify({email:payload.email,answers:payload.answers});
  function attribution() {
    let values = {};
    try {
      const saved = JSON.parse(sessionStorage.getItem(ATTRIBUTION_KEY) || '{}');
      ATTRIBUTION_FIELDS.forEach(key => { if (typeof saved[key] === 'string') values[key] = saved[key].slice(0,500); });
    } catch (_) {}
    try {
      const current = new URL(location.href);
      const incoming = {};
      ATTRIBUTION_FIELDS.forEach(key => { const value=current.searchParams.get(key);if(value)incoming[key]=value.slice(0,500); });
      // A new tagged visit replaces the previous campaign rather than mixing them.
      if (Object.keys(incoming).length) values = incoming;
      sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(values));
    } catch (_) {}
    return values;
  }
  const sourceTags = attribution();
  function sourceFor(details) {
    const source = Object.assign({}, sourceTags);
    try {
      const url = new URL(text(details.context && details.context.page_url) || location.href, location.origin);
      // Only attribution query fields are sent, never quiz answers or recovery tokens.
      url.search = '';url.hash = '';
      source.url = url.href.slice(0,500);
    } catch (_) {}
    return source;
  }
  function bodyFor(id, details, collectBrief) {
    const raw = details.answers || {};
    const brief = collectBrief();
    return {
      brief_id:id,
      email:text(details.email).trim(),
      answers:{
        recipient_name:text(brief['Recipient Name']),relationship:text(brief.Relationship),
        occasion:text(brief.Occasion),genre:text(brief.Genre),mood:text(brief.Mood),voice:text(brief['Singer Preference']),
        traits:Array.isArray(raw.traits)?raw.traits.slice():[],story:text(raw.story),message:text(raw.message),
        pronunciation:text(raw.pron),from:text(brief.From),
        prompts:raw.prompts && typeof raw.prompts==='object' && !Array.isArray(raw.prompts)?clone(raw.prompts):{},
        // This exact value is also placed on the paid song's Story property.
        story_assembled:text(brief.Story)
      },
      source:sourceFor(details),
      website:''
    };
  }
  function validPayload(payload) {
    if (!payload || !BRIEF_ID.test(payload.brief_id) || !payload.email || payload.email.length>320) return false;
    const answers=payload.answers;
    if (!answers || !['Female','Male','No preference'].includes(answers.voice)) return false;
    if (!answers.recipient_name && !answers.story && !answers.story_assembled) return false;
    const caps={recipient_name:120,story:4000,story_assembled:6000,message:1000,pronunciation:160};
    if (Object.keys(caps).some(key=>typeof answers[key]!=='string'||answers[key].length>caps[key])) return false;
    if (!Array.isArray(answers.traits)||answers.traits.length>12||answers.traits.some(value=>typeof value!=='string')) return false;
    if (!answers.prompts||typeof answers.prompts!=='object'||Array.isArray(answers.prompts)) return false;
    const prompts=Object.entries(answers.prompts);
    if (prompts.length>12||prompts.some(([,value])=>typeof value!=='string'||value.length>600)) return false;
    return new Blob([JSON.stringify(payload)]).size<60000;
  }
  function get(id) {
    if (records.has(id)) return records.get(id);
    let record={clientBriefId:id,captureRef:'',signature:'',acknowledged:'',snapshot:null,status:'idle',attempts:0,retryAt:0,inFlight:null,retryTimer:null,enabled:()=>true};
    try {
      const saved=JSON.parse(sessionStorage.getItem(PREFIX+id)||'null');
      if (saved && saved.clientBriefId===id && saved.snapshot && saved.snapshot.brief_id===id && saved.signature===signatureOf(saved.snapshot)) {
        record=Object.assign(record,saved,{inFlight:null,retryTimer:null,enabled:()=>true});
        record.captureRef=UUID.test(saved.captureRef||'')?saved.captureRef:'';
        record.attempts=Number.isInteger(saved.attempts)?Math.max(0,Math.min(MAX_ATTEMPTS,saved.attempts)):0;
        record.retryAt=Number.isFinite(saved.retryAt)?saved.retryAt:0;
        record.status=saved.status==='saved'&&record.captureRef&&saved.acknowledged===saved.signature?'saved':saved.status==='failed'?'failed':'unconfirmed';
      }
    } catch (_) {}
    records.set(id,record);
    return record;
  }
  function persist(record) {
    try {
      const saved=Object.assign({},record);
      delete saved.inFlight;delete saved.retryTimer;delete saved.enabled;
      sessionStorage.setItem(PREFIX+record.clientBriefId,JSON.stringify(saved));
    } catch (_) {}
  }
  function notify(record) {
    persist(record);
    listeners.forEach(listener=>{try{listener(record.clientBriefId,record.status);}catch(_){}});
  }
  function enabled(record) {
    return !(window.Shopify&&window.Shopify.designMode) && record.enabled();
  }
  function begin(record, explicit) {
    if (!enabled(record)||record.inFlight||!record.snapshot) return;
    if (record.captureRef&&record.acknowledged===record.signature) {record.status='saved';notify(record);return;}
    if (explicit) {record.attempts=0;record.retryAt=0;clearTimeout(record.retryTimer);record.retryTimer=null;}
    else if (record.status==='failed'||record.attempts>=MAX_ATTEMPTS) return;
    if (record.retryAt>Date.now()) {
      if (!record.retryTimer) record.retryTimer=setTimeout(()=>{record.retryTimer=null;begin(record,false);},record.retryAt-Date.now());
      return;
    }
    const snapshot=clone(record.snapshot);
    if (!validPayload(snapshot)) {record.status='failed';notify(record);return;}
    const signature=record.signature;
    const body=JSON.stringify(snapshot);
    const controller=new AbortController();
    let timer;
    record.attempts+=1;record.retryAt=0;record.status='pending';
    const operation=(async()=>{
      try {
        const deadline=new Promise((_,reject)=>{timer=setTimeout(()=>{controller.abort();reject(new Error('unconfirmed'));},6000);});
        const request=(async()=>{
          const response=await fetch(ENDPOINT,{
            method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'application/json'},
            body,signal:controller.signal,keepalive:true
          });
          if (response.status!==202) throw new Error([400,413,422].includes(response.status)?'rejected':response.status===429?'rate_limited':'unconfirmed');
          const result=await response.json();
          if (!result||!UUID.test(result.ref||'')||!['queued','generating','ready','failed'].includes(result.status)) throw new Error('unconfirmed');
          return result;
        })();
        const result=await Promise.race([request,deadline]);
        record.captureRef=result.ref;record.acknowledged=signature;
        record.status=record.signature===signature?'saved':'pending';
      } catch (error) {
        if (record.signature!==signature) record.status='pending';
        else {
          const reason=error&&error.message;
          record.attempts=Math.max(1,record.attempts);
          record.status=reason==='rejected'?'failed':'unconfirmed';
          if (reason==='rate_limited') record.attempts=MAX_ATTEMPTS;
          if (record.status==='unconfirmed'&&record.attempts<MAX_ATTEMPTS) record.retryAt=Date.now()+RETRY_DELAYS[record.attempts-1];
        }
      } finally {
        clearTimeout(timer);record.inFlight=null;notify(record);
        if (record.status==='pending'||(record.status==='unconfirmed'&&record.attempts<MAX_ATTEMPTS)) begin(record,false);
      }
    })();
    record.inFlight=operation;
    notify(record);
  }
  window.SBQ_CAPTURE={
    create:function(onChange,options){
      if(typeof onChange==='function')listeners.add(onChange);
      const allowed=()=>!(options&&typeof options.enabled==='function')||options.enabled();
      return {
        capture:function(id,details,collectBrief){
          if (!id||!allowed()||(window.Shopify&&window.Shopify.designMode)) return 'idle';
          const record=get(id);record.enabled=allowed;
          try {
            const payload=bodyFor(id,details,collectBrief);
            const signature=signatureOf(payload);
            if(record.signature!==signature){
              clearTimeout(record.retryTimer);record.retryTimer=null;
              record.signature=signature;record.snapshot=payload;record.attempts=0;record.retryAt=0;
              record.status='pending';notify(record);
            }
            begin(record,false);
          } catch (_) {record.status='failed';notify(record);}
          return record.status;
        },
        retry:function(id){const record=get(id);record.enabled=allowed;begin(record,true);return record.status;},
        status:function(id){return get(id).status;}
      };
    }
  };
})();
